import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsScriptService {
  loadGoogleScript(): void {
    const data = !!window.sessionStorage.getItem('GA4Data') && JSON.parse(window.sessionStorage.getItem('GA4Data'));
    if (data?.gaAgilysysId) {
      let scriptElement: HTMLScriptElement;
      scriptElement = document.createElement('script');
      scriptElement.src = `https://www.googletagmanager.com/gtag/js?id='${data.gaAgilysysId}'`;
      scriptElement.type = 'text/javascript';
      scriptElement.async = true;

      document.getElementsByTagName('head')[0].appendChild(scriptElement);
      let gTagScript = document.createElement('script');
      gTagScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', '${data.gaAgilysysId}');`;
      document.head.appendChild(gTagScript);
    }
  }
}
